import {
  ChangePayload,
  ChatBlock,
  ChatOptions,
  PortalBlock,
  PortalBlockType,
  TranslatesFnType,
} from '@nx-frontend/shared/types';

export interface BlockSearchCriteria {
  itemId: string;
  blocks: PortalBlock[];
}
export const isChatBlock = (block: PortalBlock): block is ChatBlock => block.type === PortalBlockType.CHAT;

export const getBlock = ({ itemId, blocks }: BlockSearchCriteria) => {
  return blocks.find((item) => item.id === itemId);
};

export const showUnsavedText = (t?: TranslatesFnType) => {
  return {
    title: t ? t('blocks.utils.delete_block_title') : 'Do you want to continue editing this widget?',
    description: t ? t('blocks.utils.delete_block_desc') : 'If you go back the widget won’t be added',
    buttonText: t ? t('blocks.utils.continue_editing') : 'Continue editing',
  };
};

export const getChatOptions = (payload: ChangePayload): ChatOptions => {
  if (payload.userId) {
    return { type: 'dm', userId: payload.userId, readonlyEnabled: !payload.membersOnly };
  } else if (payload.channelId) {
    return { type: 'channel', channelId: payload.channelId, readonlyEnabled: !payload.membersOnly };
  }
  throw Error('Unsupported chat configuration type');
};

export const parseMenuItemId = (menuNoteId: string) => {
  const [itemType, noteId] = menuNoteId.split('#');
  return { itemType, noteId };
};
